import { LIST_TYPE } from '../../../helpers/sliders/constants.js';
import axios from 'axios';

export default {
  namespaced: true,
  state: {
    items: [],
  },
  mutations: {
    updateItems(state, payload) {
      state.items = payload;
    },
  },
  actions: {
    async fetchItems(context, { listType, setId }) {
      const listUrl = `${API_SERVICE_HOST}${_.template(LIST_TYPE[listType].listUri)({ setId })}`; //'https://product.cardkingdom.devel:8443/product/list/hotbuy';//
      try {
        const items = await axios.get(listUrl);
        let compactList = _.uniqBy(items.data.list,'id');
        context.commit('updateItems', compactList);
      } catch (e) {}
    },
  },
};
